import { Calculator, BookOpen, Sparkles, Trophy, Menu, TrendingUp, GraduationCap, BarChart3 } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { useWorldwide, WORLDWIDE_HIDDEN_TABS } from '../context/WorldwideContext';

const BottomNav = ({ activeTab, onTabChange, onMenuClick }) => {
  const { t } = useLanguage();
  const { isWorldwide } = useWorldwide();
  
  const allNavItems = [
    { id: 'tools', labelKey: 'bottomNav.tools', icon: Calculator },
    { id: 'polymarket', label: 'Polymarket', icon: BarChart3 },
    { id: 'premium', labelKey: 'bottomNav.premium', icon: Sparkles },
    { id: 'smartcapital', label: 'CopyTrade', icon: TrendingUp, badge: 'Hot🔥' },
    { id: 'menu', labelKey: 'bottomNav.menu', icon: Menu, isMenu: true },
  ];

  const worldwideNavItems = [
    { id: 'guide', label: 'Guide', icon: GraduationCap },
    { id: 'polymarket', label: 'Polymarket', icon: BarChart3 },
    { id: 'premium', label: 'Signal', icon: Sparkles },
    { id: 'smartcapital', label: 'CopyTrade', icon: TrendingUp, badge: 'Hot🔥' },
    { id: 'menu', labelKey: 'bottomNav.menu', icon: Menu, isMenu: true },
  ];

  const navItems = isWorldwide ? worldwideNavItems : allNavItems;

  return (
    <nav style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      background: 'var(--bg-card)',
      borderTop: '1px solid var(--border-subtle)',
      padding: '8px 0 env(safe-area-inset-bottom, 8px)',
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      zIndex: 100,
      boxShadow: '0 -2px 10px rgba(0,0,0,0.1)'
    }}>
      {navItems.map((item) => {
        const isActive = !item.isMenu && activeTab === item.id;
        
        return (
          <button
            key={item.id}
            onClick={() => item.isMenu ? onMenuClick() : onTabChange(item.id)}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '4px',
              padding: '8px 12px',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              color: isActive ? '#FF4081' : 'var(--text-muted)',
              transition: 'all 0.2s ease',
              minWidth: '60px'
            }}
          >
            <div style={{
              padding: '6px',
              borderRadius: '10px',
              background: isActive ? 'rgba(255, 64, 129, 0.1)' : 'transparent',
              transition: 'all 0.2s ease',
              position: 'relative'
            }}>
              <item.icon size={22} />
              {item.badge && <span style={{ position: 'absolute', top: '2px', right: '-8px', fontSize: '7px', fontWeight: '800', color: '#fff', background: 'linear-gradient(135deg, #F97316 0%, #EF4444 100%)', padding: '2px 5px', borderRadius: '6px', lineHeight: 1.2, boxShadow: '0 0 6px rgba(249,115,22,0.5)' }}>{item.badge}</span>}
            </div>
            <span style={{ 
              fontSize: '10px', 
              fontWeight: isActive ? '600' : '500'
            }}>
              {item.label || t(item.labelKey)}
            </span>
          </button>
        );
      })}
    </nav>
  );
};

export default BottomNav;
